import { Injectable } from '@angular/core';

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
    intercom_l?: () => void;
  }
}

export type IdentityEvent = 'user_signed_in' | 'user_signed_out';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  /**
   * The Intercom tag in Google Tag Manager reads the signed in user from local storage when it
   * runs, so it keeps whichever identity the page was loaded with. Tell it to read again once the
   * identity changed, and push a dataLayer event other tags can trigger on. Both are no-ops when
   * Tag Manager is absent, which is the case for the development build.
   *
   * Call this after local storage has been updated, not before.
   */
  identityChanged(event: IdentityEvent): void {
    try {
      window.dataLayer = window.dataLayer ?? [];
      window.dataLayer.push({ event });
      window.intercom_l?.();
    } catch {
      // Analytics must never break the application.
    }
  }
}
